import { IHasClassName } from '@/interfaces';
import { cn } from '@/lib/utils';

const CommaSeparator = ({ className }: IHasClassName) => (
  <span className={cn(
    'text-muted-foreground/20',
    className
  )}>
    •
  </span>
)

export default CommaSeparator;
